// src/components/spinner/ContentLoader.jsx
// this will load in the layout content

import React from "react";
import { MultiOrbitSpinner3 } from "../../lib/myIcons";

export default function ContentLoader() {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "200px", // or any height you want
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(255,255,255,0.5)", // semi-transparent overlay
      }}
    >
      <MultiOrbitSpinner3 />
    </div>
  );
}
